import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
// eslint-disable-next-line no-unused-vars
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import viewIcon from "../../assets/images/icons/eye.svg";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../utils/constants";
import editImage from "../../assets/images/icons/edit-2.svg";
import Modal from "../../commons/Modal/Modal";

function SaudiaCompetitionsManagement() {
  const [loading, setLoading] = useState(false);
  const [competitions, setCompetitions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10); // Default limit per page
  const [totalPages, setTotalPages] = useState(1);
  const [logoutModal, setLogoutModal] = useState({ value: false });
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);

  const getMediaUrl = (path) => {
    if (!path) return null;
    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }

    const apiBaseUrl = process.env.REACT_APP_API?.replace("/v1", "")?.replace("/admin", "") || "";
    const baseUrl = apiBaseUrl.endsWith("/") ? apiBaseUrl.slice(0, -1) : apiBaseUrl;
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${baseUrl}${normalizedPath}`;
  };

  const getCompetitions = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", currentPage.toString());
      params.append("limit", limit.toString());
      if (searchTerm) {
        params.append("search", searchTerm);
      }

      const response = await handleApiCall("get", `${endpoints.getCompetitionList}?${params.toString()}`);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const responseData = response?.data?.data;
        const competitionsData = Array.isArray(responseData?.competition)
          ? responseData.competition
          : Array.isArray(responseData?.competititon) // backend typo fallback
          ? responseData.competititon
          : Array.isArray(responseData?.data)
          ? responseData.data
          : Array.isArray(responseData)
          ? responseData
          : [];

        setCompetitions(competitionsData);
        setTotalPages(responseData?.totalPages || responseData?.pagination?.totalPages || 1);
      } else if (response?.error) {
        console.error("Error fetching competitions:", response?.message);
        setCompetitions([]);
      } else {
        setCompetitions([]);
      }
    } catch (error) {
      console.error("Error fetching competitions:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, limit, searchTerm]);

  useEffect(() => {
    getCompetitions();
  }, [getCompetitions]);

  // eslint-disable-next-line no-unused-vars
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusToggle = async (itemId, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;
      setStatusUpdatingId(itemId);

      const response = await handleApiCall("put", endpoints.updateCompetitionStatus, {
        competition_id: itemId,
        status: newStatus,
      });

      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success("Competition status updated successfully!");
        getCompetitions();
      } else if (response?.error) {
        console.error("Error updating competition status:", response?.message);
      }
    } catch (error) {
      console.error("Error updating competition status:", error);
    } finally {
      setStatusUpdatingId(null);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleDeleteClick = (itemId) => {
    setItemToDelete(itemId);
    setLogoutModal({ value: true });
  };

  const handleDeleteConfirm = async () => {
    if (!itemToDelete) return;

    setDeleting(true);
    try {
      // TODO: Replace with actual API endpoint
      // const response = await handleApiCall("delete", `${endpoints.deleteBanner}/${itemToDelete}`);

      // if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
      //   toast.success("Competition deleted successfully!");
      //   setLogoutModal({ value: false });
      //   setItemToDelete(null);
      //   getCompetitions();
      // }
    } catch (error) {
      console.error("Error deleting competition:", error);
    } finally {
      setDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setLogoutModal({ value: false });
    setItemToDelete(null);
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Saudia Competitions Management</h3>
              <Link to="/add-saudia-competition" className="btn btn-primary rounded-2 px-3 ml-auto">
                {UI_CONSTANTS.BUTTON_LABELS.CREATE_NEW} <span className="ml-2">+</span>
              </Link>
            </div>

            {/* Search Bar */}
            {/* <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control search-icon left-icon border"
                    placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div> */}

            <div className="table-responsive px-0">
              <table className="table table-striped trim">
                <thead>
                  <tr>
                    <th width="80">{UI_CONSTANTS.TABLE_HEADERS.SR_NO}</th>
                    <th width="150">{UI_CONSTANTS.TABLE_HEADERS.NAME}</th>
                    <th>Image</th>
                    <th>Order By</th>
                    <th>{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                    <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                        </div>
                      </td>
                    </tr>
                  ) : !Array.isArray(competitions) || competitions.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                      </td>
                    </tr>
                  ) : (
                    competitions.map((item, index) => {
                      const itemId = item._id || item.id || item.competition_id || `competition-${index}`;
                      const imageUrl = getMediaUrl(
                        item.desktop_image ||
                          item.desktopImage ||
                          item.image ||
                          item.image_url ||
                          item.imageUrl ||
                          item.video ||
                          item.video_url ||
                          item.videoUrl
                      );
                      const title = item.title_en || item.title_english || item.title || "";
                      const status = item.status ?? 0;
                      const order_no = item.order_no;

                      return (
                        <tr key={itemId}>
                          <td>{(currentPage - 1) * limit + index + 1}</td>
                          <td className="text-center">{title || UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}</td>
                        <td>
                          <div className="sm-img">
                            {imageUrl ? (
                              <img
                                src={imageUrl}
                                alt="Competition"
                                style={{
                                  width: "100px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            ) : (
                              <span style={{ color: "#999" }}>No image</span>
                            )}
                          </div>
                        </td>
                        <td>{order_no}</td>
                        <td>
                          <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              checked={status === 1}
                              onChange={() => handleStatusToggle(itemId, status)}
                              disabled={statusUpdatingId === itemId}
                            />
                            <span className="custom-control-label custom-toggle" />
                          </label>
                        </td>
                        <td>
                          <div className="d-flex align-items-center justify-content-center">
                            <Link to={`/view-saudia-competition/${itemId}`} className="btn btn-link p-0 mx-2" title={UI_CONSTANTS.BUTTON_LABELS.VIEW || "View"}>
                              <img src={viewIcon} alt={UI_CONSTANTS.BUTTON_LABELS.VIEW || "View"} style={{ width: 20, height: 20, filter: "brightness(0) invert(1)", opacity: 0.95 }} className="mr-2" />
                            </Link>
                            <Link to={`/edit-saudia-competition/${itemId}`} className="btn btn-link p-0 mx-2">
                              <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                            </Link>
                            {/* <button className="btn btn-link p-0 mx-2" onClick={() => handleDeleteClick(itemId)}>
                              <img src={DeleteIcon} alt={UI_CONSTANTS.BUTTON_LABELS.DELETE} />
                            </button> */}
                          </div>
                        </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        {UI_CONSTANTS.BUTTON_LABELS.PREVIOUS || "Previous"}
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        {UI_CONSTANTS.BUTTON_LABELS.NEXT || "Next"}
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal show={logoutModal.value} onClose={handleDeleteCancel} style={{ zIndex: "1000" }} className=" shadow-none">
        <div className="modal-dialog modal-md modal-center" role="document">
          <div className="modal-content bg-black border-light">
            <div className="modal-body text-center my-4 py-4">
              <h4 className="text-white">
                Do you want to
                <br />
                Delete this competition?
              </h4>
              <div className="col-sm-12 mx-auto d-flex align-items-center mt-4 row">
                <div className="col-6 px-2">
                  <button type="button" className="btn btn-primary btn-lg btn-block font-16 rounded-pill" onClick={handleDeleteConfirm} disabled={deleting}>
                    {deleting ? "Deleting..." : "Yes"}
                  </button>
                </div>
                <div className="col-6 px-2">
                  <button type="button" className="btn btn-default btn-lg btn-block font-16 rounded-pill" onClick={handleDeleteCancel} disabled={deleting}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default SaudiaCompetitionsManagement;

